import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface AuthState {
    token: string;
    isAuthenticated: boolean;
    refreshToken: string | null;
}

const initialState: AuthState = {
    token: '',
    isAuthenticated: false,
    refreshToken: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
            state.isAuthenticated = true;
        },
        clearToken: (state) => {
            state.token = '';
            state.isAuthenticated = false;
        },
        setRefreshToken: (state, action: PayloadAction<string>) => {
            state.refreshToken = action.payload;
            state.isAuthenticated = true;
        },
    },
});

export const {setToken, clearToken, setRefreshToken} = authSlice.actions;

export default authSlice.reducer;
